import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { ALLOWED_CONTENT_STATUSES } from '../constants.tsx';

import useLabelsSelectPropsQuery, {
	type useLabelsSelectPropsQuery$data,
	type useLabelsSelectPropsQuery$variables,
} from './__generated__/useLabelsSelectPropsQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

export function preloadLabels({ contentId }: { contentId: string }):
	| Promise<void>
	| Promise<{
			data: useLabelsSelectPropsQuery$data | null;
			errors?: ReadonlyArray<GraphQLError>;
			hasErrors: boolean;
	  }> {
	if (!contentId) {
		return Promise.resolve();
	}
	return query<useLabelsSelectPropsQuery$data, useLabelsSelectPropsQuery$variables>({
		query: useLabelsSelectPropsQuery,
		variables: {
			contentId,
			status: ALLOWED_CONTENT_STATUSES,
			refetchQuery: false,
		},
		fetchPolicy: 'network-only',
	});
}
